import { Location } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActionLabels, MarketplaceExtendedQuery, MarketplaceItemExtended, MarketplaceService } from '@fgb/core';
import { firstValueFrom, Observable, Subject, tap } from 'rxjs';
@Component({
  selector: 'fgb-marketplace-detail-page',
  templateUrl: './marketplace-detail-page.component.html',
  styleUrls: ['./marketplace-detail-page.component.scss'],
})
export class MarketplaceDetailPageComponent implements OnInit {
  @Input() id: number;
  actionLabels = ActionLabels;
  marketplaceItem$: Observable<MarketplaceItemExtended | undefined>;
  marketplaceItemType: { backLink: string; type?: string; group?: string } = { backLink: '/rewards/marketplace' };
  destroyed$ = new Subject<void>();

  constructor(
    private router: Router,
    private marketplaceExtendedQuery: MarketplaceExtendedQuery,
    private marketplaceService: MarketplaceService,
    private location: Location
  ) {}

  ngOnInit() {
    this.fetchMarketplace();
  }

  fetchMarketplace() {
    firstValueFrom(this.marketplaceService.fetchMarketplaceItemById(this.id))
      .then(() => {
        this.marketplaceItem$ = this.marketplaceExtendedQuery.selectExtendedMarketplaceItem(this.id).pipe(
          tap((item) => {
            if (item) {
              this.marketplaceItemType = this.marketplaceExtendedQuery.getMarketplaceItemType(item);
            }
          })
        );
      })
      .catch(() => {
        // Redirect to 404 page if the item is not found in the database
        this.router.navigate(['/404page']);
      });
  }

  goBack() {
    this.location.back();
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
